import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from "../../../../_services/auth.service";
import {StorageService} from "../../../../_services/storage.service";
import Swal from "sweetalert2";
import {MenusService} from "../../../../_services/menu.service";
import {AlertService} from "../../../../_services/alert.service";
import {environment} from "../../../../../environments/environment";
import { DOCUMENT } from '@angular/common';
import * as testing from "src/assets/js/testing.js";
import { catchError, EMPTY, tap } from 'rxjs';
import { InactivityService } from 'src/app/_helpers/inactivity-check-service';
// import * as google from "src/assets/js/google.js";

const {API_URL} = environment

declare var googleTranslateElementInit: Function;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  ReadMore:boolean = true

  //hiding info box
  visible:boolean = false


  returnUrl: any;
  form: any = {
    username: null,
    password: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];
  checked: boolean = false;
  public emailRegex = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$'

  constructor(private inactivityService : InactivityService ,private menuService: MenusService, private alertService: AlertService, private router: Router, private route: ActivatedRoute, private authService: AuthService, private storageService: StorageService,@Inject(DOCUMENT) private readonly document: Document) {
  }

  getCookie(name: any): any {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts;
  }

  Remember(event: any) {
    //  this.checked = event.checked

    function setCookie(key: any, value: any) {
      document.cookie = key + "=" + escape(value) +
        ";domain=" + window.location.hostname +
        ";path=/";
    }

    // delete cookie
    function deleteCookie(name: any) {
      // setCookie(name, "");
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    // var remember_me_check_box = $("#authCheck")
    // handle click and add & delete cookie

    if (this.checked) {
      deleteCookie('authCheck');
      // localStorage.removeItem('authCheck');
      //  localStorage.removeItem('authCheck');
      var username = this.form.username
      var password = this.form.password
      var data = {[username]: password}
      var dataString = JSON.stringify(data)
      var encData = btoa(dataString)
      setCookie('authCheck', encData);
      //   localStorage.setItem('authCheck', btoa(this.f.username.value+","+ this.f.password.value));
      //   localStorage.setItem('authCheck', btoa(this.f.username.value+","+ this.f.password.value));

    }
    // else {
    //   deleteCookie('authCheck');
    //   localStorage.removeItem('authCheck');
    //   localStorage.removeItem('authCheck');

    //   setCookie('authCheck', 'no');
    //   localStorage.setItem('authCheck', 'no');
    //   localStorage.setItem('authCheck', 'no');
    // }
  }

  toggle(event: any) {

    this.checked = event.target.checked
  }

  ngOnInit() {
    console.log("Login Page ");
    googleTranslateElementInit()
    
    // Check if this is an inactivity logout
    const logoutReason = this.route.snapshot.queryParams['reason'];
    if (logoutReason === 'inactivity') {
      console.log("🔴 Inactivity logout detected - forcing isLoggedIn to false");
      this.isLoggedIn = false;
      
      // Clear the query parameter to avoid it persisting in URL
      this.router.navigate(['/auth/login'], { replaceUrl: true });
    }
    
    if (this.getCookie('authCheck')) {
      var w = this.getCookie('authCheck')[1]
      var x = atob(decodeURIComponent(w))
      var y = JSON.parse(x)

      if (y) {
        var user = Object.keys(y)[0]
        var pass = Object.values(y)[0]
        //y[1].split(',')[1]
        this.form.username = user
        this.form.password = pass

      }
    }

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    
    // Only check if logged in for non-inactivity cases
    if (logoutReason !== 'inactivity' && this.storageService.isLoggedIn()) {
      this.isLoggedIn = true;
      this.roles = this.storageService.getUser().roles;
      this.router.navigate([this.returnUrl]);
    }

    this.updateTime();
    this.checkIdleTime();
    document.addEventListener('click', this.handleUserActivity.bind(this));
  }

  // onLoggedin(e: Event) {
  //   e.preventDefault();
  //   localStorage.setItem('isLoggedin', 'true');
  //   if (localStorage.getItem('isLoggedin')) {
  //     this.router.navigate([this.returnUrl]);
  //   }
  // }

  onLoggedin(e: Event, f: any): void {
    console.log(this.form.username);
    this.visible = true
    if(this.form.username != "" && this.form.password != ""){
      this.visible = false
      e.preventDefault();
      console.log(f.form.status)
      if (f.form.status == 'VALID') {
        var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/
        var res = regex.test(this.form.username)
        console.log(res);
        if(!res){
          this.visible = true;
          return;
        }
        var {username, password} = this.form;


        var button = document.getElementById('password') as HTMLElement;

        this.authService.loginNew(username, password).subscribe({
          next: data => {
            console.log("===============>", data)
            if (data.response.status != 200) {
              this.ReadMore = !this.ReadMore;
              this.visible = true
              return
            }console.log('Login response data:', data);

            
     
            // Continue with normal login flow if 2FA is not enabled
            this.visible = false
            this.Remember('');
            this.alertService.toastSuccessMessageAlert({
              title: 'Login successfully',
              html: '<b>Welcome...</b>'
            });
             console.log("Before Saving")
            this.storageService.saveUser(data.response.data);
            this.storageService.setName(data.response.data.accessToken)
            console.log("After Saving")
    
            // Start SSE connection for notifications after successful login
            // this.authService.startNotificationStream();

            this.authService.getUserProfileNew().subscribe((response:any)=>{
              this.authService.setTrackingTimer();
                console.log(response.data)
                console.log(this.menuService.transformApiResponse(response.data))
                const menuData = this.menuService.structuredMenu(this.menuService.transformApiResponse(response.data))
                localStorage.setItem('menuItemsFormatted', JSON.stringify(menuData));
            })
            this.isLoginFailed = false;
            this.isLoggedIn = true;
            this.roles = this.storageService.getUser().roles;
            if (this.storageService.isLoggedIn()) {
              console.log(this.returnUrl);
              // if(this.returnUrl){
              //   console.log(this.returnUrl);
              //   this.router.navigate([this.returnUrl])
              // }else{
              //   this.router.navigate(['/']);
              // }
              // .then(() => {
              //   this.router.navigate(['/merchants/merchant-master']);
              //   });
              // console.log("==========>", this.returnUrl)
            }
            // this.reloadPage();

            this.router.navigate(['/']);
            return;

            const token = data.accessToken;
            const tokenParts = token.split('.');
            if (tokenParts.length === 3) {
              const payload = JSON.parse(atob(tokenParts[1]));
              console.log('Decoded token payload:', payload);
              
              // Now check the TFA flags from the decoded token
              if (payload.isTFAEnabled === "true" || payload.isTFAEnabled === true) {
                localStorage.setItem('tfaUsername', username);
                localStorage.setItem('tfaToken', token);
                
                if (payload.isTfaQrGranted === "false" || payload.isTfaQrGranted === false) {
                  console.log('Redirecting to TFA setup');
                
                  this.router.navigate(['/auth/tfa-setup']);
                  return;
                } else {
                  console.log('Redirecting to TFA verify');
                 
                  this.router.navigate(['/auth/tfa-verify']);
                  return;
                }
              }
              else
              {
                // TFA is not enabled, redirect to home page
                this.router.navigate(['/']);
                return;
              }
            }
          },
          error: err => {
            this.alertService.toastErrorMessageAlert({
              title: 'Something went wrong!',
            })

            // Swal.fire({
            //   icon: 'error',
            //   title: 'Oops...',
            //   text: 'Something went wrong!',
            //   // footer: '<a href>Why do I have this issue?</a>'
            // })
            // console.log("err====>", err);
            this.errorMessage = err.error?.message;
            this.isLoginFailed = true;
          }
        });
      }
      f.submitted=true
    }
  }

  reloadPage(): void {
    window.location.reload();
  }


//session implementaion
currentTime: string = '';
  idleTimer: string = '';
  idleTime: number = 0;
  idleThreshold: number = 900; // Adjust this threshold as needed (in seconds)
  updateTime(): void {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    this.currentTime = `${hours}:${minutes}:${seconds}`;
  }

  handleUserActivity(): void {
    this.idleTime = 0;
    this.updateIdleTimer();
  }

  checkIdleTime(): void {
    setInterval(() => {
      this.idleTime++;
     if (this.idleTime >= this.idleThreshold) {
        this.logout();
        this.idleTime = 0;
      } else {
     
       
        this.updateIdleTimer();
      }
    }, 1000);
  }

  updateIdleTimer(): void {
    const remainingTime = this.idleThreshold - this.idleTime;
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;   
 //this.idleTimer = `Logout in ${minutes}m ${seconds}s`;
  }

  logout(): void {
     // location.reload();
    this.inactivityService.stopInactivityTracking();
    this.authService.logout('inactivity');  // Pass 'inactivity' as reason for idle timeout
  }


}
